import { useState, useMemo } from "react";
import {
    Box,
    Typography,
    Button,
    IconButton,
    InputBase,
} from "@mui/material";
import AddRounded from "@mui/icons-material/AddRounded";
import RemoveRounded from "@mui/icons-material/RemoveRounded";
import {useTranslation} from "react-i18next";
import {PRODUCT_INFO} from "../../../locales/components/namespaces";

const TOKENS = {
    magenta: "#E5007E",
    black: "#111111",
    white: "#FCFCFC",
    grayBg: "#E9E9E9",
};

type CartSummarySectionProps = {
    netValue: number;
    vat: number;
    total: number;
    onApplyCoupon?: (code: string, discountPct: number) => void;
    onCheckout: () => void;
};

export default function CartSummarySection({
                                               netValue = 89.6,
                                               vat = 21.5,
                                               total = 111.1,
                                               onApplyCoupon,
                                               onCheckout,
                                           }: CartSummarySectionProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [couponCode, setCouponCode] = useState("");
    const [discountPct, setDiscountPct] = useState(0);
    const [error, setError] = useState(null);
    const {t} = useTranslation(PRODUCT_INFO);

    const fmt = (n: number) =>
        n.toFixed(2).replace(".", ",") + " €";

    const { finalNet, finalVat, finalTotal, discountAmount } = useMemo(() => {
        if (!discountPct) {
            return {
                finalNet: netValue,
                finalVat: vat,
                finalTotal: total,
                discountAmount: 0,
            };
        }

        const factor = 1 - discountPct;
        const discountedTotal = total * factor;
        const discountedNet = netValue * factor;
        const discountedVat = vat * factor;

        return {
            finalNet: discountedNet,
            finalVat: discountedVat,
            finalTotal: discountedTotal,
            discountAmount: total - discountedTotal,
        };
    }, [netValue, vat, total, discountPct]);

    const hasDiscount = discountPct > 0;

    const handleToggleOpen = () => {
        setIsOpen((prev) => !prev);
    };

    const handleRemoveCouponInternal = () => {
        setDiscountPct(0);
        setCouponCode('')
    };
    const handleApply = () => {
        const code = couponCode.trim().toUpperCase();

        if (!code) {
            setDiscountPct(0);
            return;
        }


        if (code === "BREW10") {
            const pct = 0.1;
            setDiscountPct(pct);
            setError(null);
            onApplyCoupon?.(code, pct);
        } else {
            setDiscountPct(0);
            setError("Μη έγκυρος κωδικός.");
        }
    };

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 380,
                display: "flex",
                flexDirection: "column",
                gap: 2.5,
            }}
        >
            {/*<Box*/}
            {/*    sx={{*/}
            {/*        boxSizing: "border-box",*/}
            {/*        borderRadius: 2,*/}
            {/*        border: `1px solid ${TOKENS.magenta}`,*/}
            {/*        bgcolor: TOKENS.grayBg,*/}
            {/*        px: 2.5,*/}
            {/*        py: 1.5,*/}
            {/*        display: "flex",*/}
            {/*        flexDirection: "column",*/}
            {/*        gap: 1.5,*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <Box*/}
            {/*        sx={{*/}
            {/*            display: "flex",*/}
            {/*            alignItems: "center",*/}
            {/*            justifyContent: "space-between",*/}
            {/*            gap: 2,*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        <Typography*/}
            {/*            sx={{*/}
            {/*                fontFamily: "'Roboto Condensed', system-ui, sans-serif",*/}
            {/*                fontWeight: 400,*/}
            {/*                fontSize: 16,*/}
            {/*                lineHeight: 1.2,*/}
            {/*                color: TOKENS.magenta,*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            {t("Do you have a discount coupon?")}*/}
            {/*        </Typography>*/}

            {/*        <IconButton*/}
            {/*            size="small"*/}
            {/*            onClick={handleToggleOpen}*/}
            {/*            sx={{*/}
            {/*                width: 28,*/}
            {/*                height: 28,*/}
            {/*                borderRadius: "50%",*/}
            {/*               // border: `1.4px solid ${TOKENS.magenta}`,*/}
            {/*                //bgcolor: TOKENS.white,*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            {isOpen ? (*/}
            {/*                <RemoveRounded sx={{ fontSize: 18, color: TOKENS.magenta }} />*/}
            {/*            ) : (*/}
            {/*                <AddRounded sx={{ fontSize: 18, color: TOKENS.magenta }} />*/}
            {/*            )}*/}
            {/*        </IconButton>*/}
            {/*    </Box>*/}

            {/*    {isOpen && (*/}
            {/*        <Box*/}
            {/*            sx={{*/}
            {/*                mt: 1,*/}
            {/*                display: "flex",*/}
            {/*                flexDirection: "column",*/}
            {/*                gap: 1.5,*/}
            {/*            }}*/}
            {/*        >*/}
            {/*            <InputBase*/}
            {/*                placeholder={t("Enter the code")}*/}
            {/*                fullWidth*/}
            {/*                value={couponCode}*/}
            {/*                onChange={(e) => setCouponCode(e.target.value)}*/}
            {/*                sx={{*/}
            {/*                    height: 38,*/}
            {/*                    bgcolor: "#F0F0F0",*/}
            {/*                    borderRadius: "6px",*/}
            {/*                    px: 1.5,*/}
            {/*                    fontFamily: "'Roboto Condensed', sans-serif",*/}
            {/*                    fontSize: 14,*/}
            {/*                    fontWeight: 400,*/}
            {/*                    color: TOKENS.black,*/}
            {/*                    "::placeholder": {*/}
            {/*                        color: "#9B9B9B",*/}
            {/*                        opacity: 1,*/}
            {/*                    },*/}
            {/*                }}*/}
            {/*            />*/}
            {/*            <Box*/}
            {/*            sx={{*/}
            {/*                display:{xs:'grid',sm:'grid',md:'flex',lg:'flex'},*/}
            {/*                gap:1*/}
            {/*            }}*/}
            {/*            >*/}
            {/*                <Button*/}
            {/*                    onClick={handleApply}*/}
            {/*                    sx={{*/}
            {/*                        alignSelf: "flex-start",*/}
            {/*                        borderRadius: 999,*/}
            {/*                        px: 3,*/}
            {/*                        py: 1,*/}
            {/*                        bgcolor: TOKENS.magenta,*/}
            {/*                        color: TOKENS.white,*/}
            {/*                        textTransform: "uppercase",*/}
            {/*                        fontFamily: "'Zen Maru Gothic', system-ui, sans-serif",*/}
            {/*                        fontWeight: 900,*/}
            {/*                        fontSize: 14,*/}
            {/*                        lineHeight: 1.2,*/}
            {/*                        "&:hover": {*/}
            {/*                            bgcolor: "#c9006b",*/}
            {/*                        },*/}
            {/*                    }}*/}
            {/*                >*/}
            {/*                    {t("Add")}*/}
            {/*                </Button>*/}
            {/*                {hasDiscount && (*/}
            {/*                    <Button*/}
            {/*                        onClick={handleRemoveCouponInternal}*/}
            {/*                        sx={{*/}
            {/*                            borderRadius: 999,*/}
            {/*                            px: 3,*/}
            {/*                            py: 1,*/}
            {/*                            bgcolor: TOKENS.white,*/}
            {/*                            color: TOKENS.magenta,*/}
            {/*                            border: `1px solid ${TOKENS.magenta}`,*/}
            {/*                            textTransform: "uppercase",*/}
            {/*                            fontFamily: "'Zen Maru Gothic', system-ui, sans-serif",*/}
            {/*                            fontWeight: 900,*/}
            {/*                            fontSize: 14,*/}
            {/*                            lineHeight: 1.2,*/}
            {/*                            "&:hover": {*/}
            {/*                                bgcolor: "#c9006b",*/}
            {/*                                color: TOKENS.white,*/}
            {/*                            },*/}
            {/*                        }}*/}
            {/*                    >*/}
            {/*                        {t("Remove coupon")}*/}
            {/*                    </Button>*/}
            {/*                )}*/}
            {/*            </Box>*/}

            {/*        </Box>*/}
            {/*    )}*/}
            {/*</Box>*/}
            <Box
                sx={{
                    bgcolor: TOKENS.grayBg,
                    borderRadius: 2,
                    p: 2.5,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.75,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                fontWeight: 400,
                                fontSize: 16,
                                color: TOKENS.black,
                            }}
                        >
                            {t("Value without vat")}
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                fontWeight: 400,
                                fontSize: 16,
                                color: TOKENS.black,
                                textAlign: "right",
                            }}
                        >
                            {fmt(finalNet)}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: "space-between",
                            gap: 2,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                fontWeight: 400,
                                fontSize: 16,
                                color: TOKENS.black,
                            }}
                        >
                            {t("Vat")}
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                fontWeight: 400,
                                fontSize: 16,
                                color: TOKENS.black,
                                textAlign: "right",
                            }}
                        >
                            {fmt(finalVat)}
                        </Typography>
                    </Box>
                    {hasDiscount && (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 2,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                    fontWeight: 400,
                                    fontSize: 16,
                                    color: TOKENS.magenta,
                                }}
                            >
                                {t("Discount")} ({Math.round(discountPct * 100)}%)
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                    fontWeight: 400,
                                    fontSize: 16,
                                    color: TOKENS.magenta,
                                    textAlign: "right",
                                }}
                            >
                                -{fmt(discountAmount)}
                            </Typography>
                        </Box>
                    )}

                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                            mt: 0.5,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                fontWeight: 700,
                                fontSize: 20,
                                color: TOKENS.black,
                            }}
                        >
                            {t("Total")}
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: "'Roboto Condensed', system-ui, sans-serif",
                                fontWeight: 700,
                                fontSize: 20,
                                color: TOKENS.black,
                                textAlign: "right",
                            }}
                        >
                            {fmt(finalTotal)}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Button
                onClick={onCheckout}
                fullWidth
                sx={{
                    mt: 0.5,
                    borderRadius: 999,
                    px: 3,
                    py: 1.5,
                    bgcolor: TOKENS.magenta,
                    color: TOKENS.white,
                    textTransform: "uppercase",
                    fontFamily: "'Zen Maru Gothic', system-ui, sans-serif",
                    fontWeight: 900,
                    fontSize: 16,
                    lineHeight: 1.2,
                    "&:hover": {
                        bgcolor: "#c9006b",
                    },
                }}
            >
                {t("Complete Order")}
            </Button>
        </Box>
    );
}
